import React from 'react';
import { timeService } from '../services/time/time-service';

export default function useTimeNow(props: { intervalSeconds: number }) {
    const [now, setNow] = React.useState(timeService.currentTime);

    React.useEffect(() => {
        setNow(timeService.currentTime);
        return timeService.on((t, sourceChanged) => {
            if (t % props.intervalSeconds && !sourceChanged) {
                return;
            }
            setNow(t);
        });
    }, [props.intervalSeconds]);

    return now;
}
